import React, { useContext, useRef } from 'react';
import { TrackingContext } from './TrackingContext.jsx';
import { TrinityEvents } from '../modules/teaser/trinity.js';
import {
    handleEntryStylesProductSlider,
    handleEntryStylesRecommendation
} from '../modules/teaser/teaser-entry-cookie-functions.js';

/**
 * @typedef {Object} TeaserLinkModel
 * @property {string} linkUrlBasePath
 * @property {string} linkUrlQueryParameter
 * @property {{ teaserEntryCookieJSON: string }} linkObject
 * @property {string} linkAltTitle
 */

/**
 * @param {ReactNode} children
 * @param {TeaserLinkModel} model
 * @param {string} [className]
 * @param {string | null} [hash]
 * @returns {JSX.Element}
 */
export function Link({children, model, className, hash, ...linkProps}) {
    const linkSet = useRef(false);
    if (!model.linkUrlBasePath) {
        return children;
    }
    const landmarkConfig = useContext(TrackingContext);
    function appendQueryParameters(event) {
        if (model.linkUrlQueryParameter && !linkSet.current) {
            if (event.target.tagName !== 'A') {
                const parent = event.target.parentElement;
                if (parent.tagName === 'A') {
                    event.target = parent;
                }
            }

            const urlParams = new URLSearchParams(window.location.search);
            const additionalParams = [];

            if (urlParams.has("dateOverride")) {
                additionalParams.push(`dateOverride=${encodeURIComponent(urlParams.get("dateOverride"))}`);
            }
            if (urlParams.has("timeOverride")) {
                additionalParams.push(`timeOverride=${encodeURIComponent(urlParams.get("timeOverride"))}`);
            }
            if (urlParams.has("preview")) {
                additionalParams.push(`preview=${encodeURIComponent(urlParams.get("preview"))}`);
            }

            const baseHref = model.linkUrlBasePath + (hash ? `#${hash}` : '');
            const query = [model.linkUrlQueryParameter, ...additionalParams].filter(Boolean).join('&');
            event.target.href = query ? `${baseHref}?${query}` : baseHref;

            linkSet.current = true;
        }
    }

    return (
        <a
            href={model.linkUrlBasePath + (hash ? `#${hash}` : '')}
            className={className}
            onClick={(e) => {
                appendQueryParameters(e);
                TrinityEvents.sendTeaserClick(landmarkConfig);
                if (model.linkObject?.teaserEntryCookieJSON) {
                    handleEntryStylesRecommendation(model.linkObject.teaserEntryCookieJSON);
                    handleEntryStylesProductSlider(model.linkObject.teaserEntryCookieJSON);
                }
            }}
            onAuxClick={appendQueryParameters}
            onFocus={appendQueryParameters}
            {...linkProps}
            title={model.linkAltTitle}
        >
            {children}
        </a>
    );
}